
import BBBLogo from './BBBLogo.vue'
import BCorpLogo from './BCorpLogo.vue'

export default {
  components: {
    BCorpLogo,
    BBBLogo,
  },
  props: {
    logos: { type: Array, required: true },
  },
}
